import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-footer" }
const _hoisted_2 = { class: "brand" }
const _hoisted_3 = { class: "tag" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "mark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "name" }, "Rainbow Manager", -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('welcomeSubText')), 1)
    ]),
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, { to: "/consultation" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('consultation')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/FAQ" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('FAQ')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/contacts" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('contacts')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/signUp" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('signUp')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        href: _ctx.privacyUrl,
        target: "_blank",
        rel: "noopener"
      }, _toDisplayString(_ctx.t('privacyPolicy')), 9, _hoisted_4),
      _createElementVNode("a", {
        href: _ctx.termsUrl,
        target: "_blank",
        rel: "noopener"
      }, _toDisplayString(_ctx.t('termsOfService')), 9, _hoisted_5),
      _createVNode(_component_router_link, { to: "/account/delete" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('accountDeleteTitle')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_6, "© " + _toDisplayString(_ctx.years) + " Rainbow Manager", 1)
  ]))
}